export default "__VITE_ASSET__Cm2$CFMq__"